<div class="content" [ngClass]="{'p-5': hasPadding}">
  <div *ngIf="displayHeader" class="columns">
    <div class="column">
      <p class="is-bold is-size-5 color-darkblue">Für diese Behördenauskunft benötigen wir zusätzliche Angaben:</p>
    </div>
  </div>

  <form [formGroup]="productValueForm">
    <ng-container *ngFor="let product of products">
      <ng-container *ngIf="product.productValues?.length">
        <div *ngIf="displayDocName" class="columns">
          <div class="column">
            <p class="is-bold is-size-6">{{ NameFinderUtils.getProductLongName(product.nameShort, products, null) }}</p>
          </div>
        </div>
        <div class="columns" *ngFor="let productValue of product.productValues">
          <div class="column">
            <label class="label has-text-weight-medium" [for]="productValue.key">
              {{ productValue.name }}
              <span *ngIf="productValue.required" class="has-text-danger">*</span>
              <span *ngIf="productValue.description"
                    class="mb-1 has-text-weight-light is-inline-block">- {{ productValue.description }}</span>
            </label>

            <div class="control">
              <input
                  [type]="productValue.type"
                  class="border-input"
                  [ngClass]="{ 'has-error': FormUtils.hasError(productValueForm.get(productValue.key)) }"
                  [formControlName]="productValue.key"
                  [id]="productValue.key"
                  [placeholder]="productValue.name"
              />
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </form>

  <div class="columns">
    <div class="column is-one-third">
      <a *ngIf="displayCancelButton" class="button back-button has-round-border" (click)="cancelModal()">
        <div class="columns is-align-items-center is-justify-content-center">
          <div class="column is-bold">
            <p class="mb-0">{{ cancelButtonText }}</p>
          </div>
        </div>
      </a>
    </div>
    <div class="column is-one-third"></div>
    <div class="column is-one-third">
      <a *ngIf="displayConfirmButton" class="button buy-button has-round-border" (click)="submitModal()">
        <div class="columns is-align-items-center is-justify-content-center">
          <div class="column is-bold">
            <p class="mb-0">{{ confirmButtonText }}</p>
          </div>
        </div>
      </a>
    </div>
  </div>
</div>
